export const LOGIN_TEXT = 'or log in with your Bitmoji account:';
export const LOGIN_FAILURE = 'Incorrect email address or password.';
export const LOGIN_FORM_CLASSNAME = 'login-okay';
export const LOGIN_FORM_CLASSNAME_FAILURE = 'login-error';
export const LOGIN_TEXT_CLASSNAME = 'login-text';
export const LOGIN_TEXT_CLASSNAME_FAILURE = 'login-text error';



// WEBPACK FOOTER //
// ./src/constants/bsauth_login_constants.js